import { motion } from 'framer-motion';
import { Award, Truck, Shield, Leaf } from 'lucide-react';

const features = [
  { icon: Award, title: 'Premium Kalite', desc: 'Birinci sınıf hammadde ile üretim' },
  { icon: Truck, title: 'Hızlı Teslimat', desc: 'Türkiye geneli hızlı kargo' },
  { icon: Shield, title: 'Güvenli Alışveriş', desc: 'Sağlığa uygun BPA-free ürünler' },
  { icon: Leaf, title: 'Çevre Dostu', desc: 'Geri dönüştürülebilir malzemeler' },
];

export default function WhyUs() {
  return (
    <section data-testid="why-us-section" className="py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <span className="text-xs font-semibold uppercase tracking-widest text-brand-dark/40">
            Neden Biz?
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark tracking-tight mt-2">
            AyzPlastik Farkı
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {features.map((feat, i) => (
            <motion.div
              key={feat.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="group p-6 rounded-2xl bg-white border border-slate-100 text-center hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-12 h-12 mx-auto rounded-xl bg-gradient-to-br from-brand-pink/30 to-brand-blue/30 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <feat.icon size={22} className="text-brand-dark" />
              </div>
              <h3 className="font-semibold text-brand-dark text-sm md:text-base mb-1">
                {feat.title}
              </h3>
              <p className="text-brand-dark/40 text-xs md:text-sm">
                {feat.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
